import classNames from "../classNames";

function noop() {}

const defaultProps = {
  positiveButton: "YES",
  negativeButton: "CANCEL",
  onPositiveClick: noop,
  onNegativeClick: noop,
  type: "danger",
  icon: "bi bi-exclamation-circle",
};

function ConfirmDialog({ title, message, icon, type }) {
  return (
    <div className="p-4">
      <div className="d-flex flex-column text-center gap-2 align-items-center">
        <i
          className={classNames(icon, "text-" + type)}
          style={{ fontSize: "3rem" }}
        ></i>
        <div className="d-flex flex-column gap-1 container-fluid align-items-center">
          <h2 className="fw-bold m-0">{title}</h2>
          <p
            className="fs-6 m-0 col-11 text-dark"
            style={{ lineHeight: "1.2rem", fontSize: "1.2rem" }}
          >
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}

ConfirmDialog.defaultProps = defaultProps;
export default ConfirmDialog;
